"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewsletterDialog = void 0;
var _zod = require("@hookform/resolvers/zod");
var _components = require("@ori-ui/components");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _react = _interopRequireWildcard(require("react"));
var _reactHookForm = require("react-hook-form");
var _createNewsletterSubscription = require("../../../../api/createNewsletterSubscription");
var _PrivacyPolicy = require("../PrivacyPolicy");
var _components2 = require("./components");
var _EmailInput = require("./components/EmailInput");
var _constants = require("./constants");
var _styles = require("./styles");
var _types = require("./types");
var _utils = require("./utils");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const NewsletterDialog = ({
  open,
  origin,
  onClose
}) => {
  const {
    getTestId
  } = (0, _testidGenerator.default)();
  const {
    content,
    setStatus,
    status
  } = (0, _components2.useNewsletterDialogContext)();
  const {
    createSubscription
  } = (0, _createNewsletterSubscription.useCreateNewsletterSubscription)();
  const {
    newsletterDialogValidationSchema
  } = (0, _utils.useValidationSchema)();
  const form = (0, _reactHookForm.useForm)({
    mode: 'onChange',
    defaultValues: {
      email: ''
    },
    resolver: (0, _zod.zodResolver)(newsletterDialogValidationSchema)
  });
  const {
    isValid
  } = (0, _reactHookForm.useFormState)({
    control: form.control
  });
  const shouldDisableSubmit = status === _types.SubscriptionProcessStatus.Initial && !isValid;
  const onSubscribe = (0, _react.useCallback)(async ({
    email
  }) => {
    await createSubscription({
      email,
      origin
    });
  }, [createSubscription, origin]);
  const handleClose = (0, _react.useCallback)(() => {
    onClose();
    setStatus(_types.SubscriptionProcessStatus.Initial);
    form.reset({
      email: ''
    });
  }, [onClose, setStatus, form]);
  const onSubsribeOrTryAgain = (0, _react.useCallback)(async () => {
    if (status === _types.SubscriptionProcessStatus.Failed) {
      setStatus(_types.SubscriptionProcessStatus.Initial);
    } else {
      await form.handleSubmit(onSubscribe)();
    }
  }, [form, onSubscribe, setStatus, status]);
  const actions = (0, _react.useMemo)(() => content.showButton ? [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Button, {
    fullWidth: true,
    "data-testid": getTestId(_constants.NEWSLETTER_DIALOG_SUBMIT),
    variant: "contained",
    color: "primary",
    disabled: shouldDisableSubmit,
    onClick: onSubsribeOrTryAgain,
    children: content.buttonText
  }, "button")] : undefined, [content.buttonText, content.showButton, getTestId, onSubsribeOrTryAgain, shouldDisableSubmit]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Root, {
    disablePortal: false,
    transitionProps: _constants.transitionProps,
    "data-testid": getTestId(_constants.NEWSLETTER_DIALOG),
    open: open,
    header: content.title,
    "aria-labelledby": _constants.NEWSLETTER_DIALOG,
    actions: actions,
    severity: content.icon,
    color: (0, _utils.getColorFromStatus)(status),
    onClose: handleClose,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactHookForm.FormProvider, {
      ...form,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Content, {
        children: [content.text, content.showForm ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmailInput.EmailInput, {}) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(_PrivacyPolicy.PrivacyPolicy, {
          text: content.ppText,
          linkText: content.ppLinkText,
          url: content.ppUrl
        })]
      })
    })
  });
};
exports.NewsletterDialog = NewsletterDialog;
